import { firestore } from '@/util/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

export type zohoNavItem = {
	text: string
	url?: string,
	section: 'destinations' | 'registration' | 'whoCanGo' | 'about' | 'answers' | 'insideHXP' | 'getAnswers' | 'legalDisclaimer' | 'contactUs',
	subSection?: string
	order?: number
	region: 'header' | 'footer'
}

export type zohoString = {
	description: string
	name: string,
	rendered: string,
	text: string
}


export async function getZohoNavLinks(){
    const zohoCollection = collection(firestore, "ZohoNavLinks");

    const links: zohoNavItem[] = [];
    const q = query(zohoCollection, where("region", "==", "footer"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        links.push(doc.data() as zohoNavItem);
    });

	return links;
}

export async function getZohoStrings(){
    const zohoCollection = collection(firestore, "ZohoStrings");

    const links: zohoString[] = [];
    const q = query(zohoCollection, where("name", "==", "zh_legalDisclaimer"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        links.push(doc.data() as zohoString);
    });

	return links;
}

